import { render, staticRenderFns } from "./KETPsaOverview.vue?vue&type=template&id=235cf336&"
import script from "./KETPsaOverview.vue?vue&type=script&lang=js&"
export * from "./KETPsaOverview.vue?vue&type=script&lang=js&"
import style0 from "./KETPsaOverview.vue?vue&type=style&index=0&id=235cf336&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports